<template>
  <div>
    <!--收藏弹框-->
    <!-- v-model="CollectModel" -->
    <Modal class="no-login-box" :value.sync="CollectModel" :closable="false" :scrollable="true" :footer-hide="true"
      :styles="{ top: '300px' }" width="300">
      <p class="item-close" @click="close()">
        <img src="static/img/popup/close.png" alt="" />
      </p>
      <p class="item-img">
        <img src="static/img/popup/icon_collect_1.png" alt="" />
      </p>
      <p class="item-txt-1">收藏成功</p>
      <p class="item-txt-2">该商品已经成功地加入了您的收藏夹</p>
      <router-link class="item-button" to="/personal/Favorites">查看我的收藏</router-link>
    </Modal>
    <!--收藏弹框-->
  </div>
</template>

<script>
export default {
  name: "Collect",
  props: {
    CollectModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // CollectModel: true
    };
  },
  methods: {
    close() {
      this.$emit("update:CollectModel", false);
    }
  }
};
</script>

<style lang="less" scoped>
.no-login-box {
  text-align: center;

  .item-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: -14px;
    top: -25px;
    cursor: pointer;
  }

  .item-img {
    width: 148px;
    height: 81px;
    margin: 37px auto auto auto;
  }

  .item-txt-1 {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-top: 18px;
  }

  .item-txt-2 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    padding-top: 6px;
  }

  .item-button {
    display: block;
    width: 250px;
    height: 40px;
    background: linear-gradient(314deg, #167C3A 0%, #53AE4E 100%);
    box-shadow: 0px 3px 12px 1px rgba(77, 152, 1, 0.3);
    border-radius: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    margin: 35px auto auto auto;
  }
}

.no-login-box /deep/ ivu-modal {}

.no-login-box /deep/ .ivu-modal-content {
  position: relative;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Collect.vue